import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { serviceChecklistStyles } from '../../../styles/classes/MobilePreviewClasses'
import ElementContainer from '../ElementContainer'
import customTheme from '../../../styles/mui_theme'

const ServiceChecklist = ({
  helpfulHint,
  disabled,
  updateCallback,
  value,
  mandatory,
  servicesSettings,
  ...rest
}) => {
  const { classes, cx } = serviceChecklistStyles()
  const [selectedItems, setSelectedItems] = useState(value || [])

  const title = servicesSettings?.title || 'Service Checklist'
  // using mock up services
  const services = [
    {
      id: 'Service 1',
      name: 'Service 1'
    },
    {
      id: 'Service 2',
      name: 'Service 2'
    },
    {
      id: 'Service 3',
      name: 'Service 3'
    }
  ]

  // Logic logic copied from your RN component
  function updateListHandler (currentList, selectedItem) {
    const isInList = currentList.find(i => i.id === selectedItem.id)
    if (isInList) {
      return currentList.filter(i => i.id !== selectedItem.id)
    } else {
      return [...currentList, selectedItem]
    }
  }

  const toggleSelection = item => {
    if (disabled) return
    const newList = updateListHandler(selectedItems, item)
    setSelectedItems(newList)
    if (updateCallback) {
      updateCallback(newList)
    }
  }

  return (
    <Box className={classes.card}>
      <ElementContainer
        title={title}
        helpfulHint={helpfulHint}
        isMandatory={mandatory}
      >
        <Box sx={{ paddingTop: '16px' }}>
          {services.map((item, index) => {
            const isSelected = selectedItems.find(s => s.id === item.id)

            return (
              <Box
                key={item.id}
                className={cx(classes.itemRow)}
                onClick={() => toggleSelection(item)}
              >
                <Box className={classes.itemLeft}>
                  <Typography className={classes.indexText}>
                    {index + 1}.
                  </Typography>
                  <Typography className={classes.itemText}>
                    {item.name}
                  </Typography>
                </Box>

                <Box
                  className={cx(classes.checkbox, {
                    [classes.checkboxChecked]: isSelected
                  })}
                >
                  {isSelected && (
                    <FontAwesomeIcon
                      icon={faCheck}
                      size="sm"
                      style={{
                        color: customTheme.colors.iconBlue
                      }}
                    />
                  )}
                </Box>
              </Box>
            )
          })}
        </Box>
      </ElementContainer>

      {/* Component Separator */}
      <Box className={classes.separator} />
    </Box>
  )
}

export default ServiceChecklist
